const ROUTES = {
  LOGIN: "login",
  SELECT_COMPANY: "select-company",
  FORGOT_PASSWORD: "forgot-password",
  RESET_PASSWORD: "reset-password",
  NO_COMPANY: "no-company",
  USER_REGISTER: "user-register",
  COMPANY_REGISTER: "company-register",
  COMPANY_INVITE: "company-invite",
  COMPANY: "company",
  PROFILE: "profile",
  COMPETENCE_MAPS: "competency-maps",
  // TODO: rolePlay возможно, поменять названия после интеграии с бэком (привести в соответствие)
  SCENARIOS: "scenarios",
  KNOWLEDGE_BLOCKS: "knowledge-blocks",
  TESTING: "testing",
  PERSONAL_TESTING: "personal",
  GROUP_TESTING: "group",
  SKILL: "skill",
  CANDIDATE: "candidate",
  QUESTION: "question",
  VACANCIES: "vacancies",
} as const;

export const PUBLIC_AUTH_ROUTES = [
  ROUTES.LOGIN,
  ROUTES.SELECT_COMPANY,
  ROUTES.FORGOT_PASSWORD,
  ROUTES.RESET_PASSWORD,
  ROUTES.NO_COMPANY,
  ROUTES.USER_REGISTER,
  ROUTES.COMPANY_REGISTER,
  ROUTES.COMPANY_INVITE,
] as const;

export const SPLIT_AUTH_ROUTES = [
  ROUTES.LOGIN,
  ROUTES.FORGOT_PASSWORD,
  ROUTES.RESET_PASSWORD,
  ROUTES.USER_REGISTER,
  ROUTES.COMPANY_REGISTER,
] as const;

const isPathMatch = (pathname: string, route: string) => pathname === route || pathname.startsWith(`${route}/`);

export const isPublicAuthRoute = (pathname: string) => {
  const normalizedPath = pathname.replace(/^\/+/, "");

  return PUBLIC_AUTH_ROUTES.some((route) => isPathMatch(normalizedPath, route));
};

export const isSplitAuthRoute = (pathname: string) => {
  const normalizedPath = pathname.replace(/^\/+/, "");

  return SPLIT_AUTH_ROUTES.some((route) => isPathMatch(normalizedPath, route));
};

export default ROUTES;
